export var DEFAULT_POLLING_INTERVAL_MS = 10000;
export var MIN_POLLING_INTERVAL_MS = 1000;
export var getPollingInterval = function (seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0)
        return DEFAULT_POLLING_INTERVAL_MS;
    return Math.max(seconds * 1000, MIN_POLLING_INTERVAL_MS);
};
export var getStatusPresentation = function (status) {
    switch ((status || '').toUpperCase()) {
        case 'APPROVED':
        case 'AUT_APPROVED':
            return { labelKey: 'result.statusApproved', kind: 'success' };
        case 'REJECTED':
        case 'REFUSED':
            return { labelKey: 'result.statusRejected', kind: 'danger' };
        case 'PROCESSING':
        case 'IN_PROCESS':
        case 'IN_PROGRESS':
            return { labelKey: 'result.statusProcessing', kind: 'progress' };
        case 'PENDING':
            return { labelKey: 'result.statusPending', kind: 'progress' };
        case 'PARTIAL':
            return { labelKey: 'result.statusPartial', kind: 'neutral' };
        case 'ERROR':
            return { labelKey: 'result.statusError', kind: 'danger' };
        default:
            // Status desconhecido: preserva o valor cru da API (identificador tecnico)
            // ou, na ausencia dele, usa o rotulo generico traduzido.
            return status
                ? { rawLabel: status, kind: 'neutral' }
                : { labelKey: 'result.statusUnavailable', kind: 'neutral' };
    }
};
